import React from 'react';
import { Clock } from 'lucide-react';
import { useAuthStore } from '../stores/authStore';
import { guardedNavigate } from '../lib/apiGuard/guardedNavigation';

const SessionExpiredModal: React.FC = () => {

  return (
    <div
      data-testid="session-expired-modal"
      style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', zIndex: 50, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}
    >
      <div style={{ background: '#fff', borderRadius: '16px', width: '90%', maxWidth: '480px', padding: '36px 32px', boxShadow: '0 20px 50px rgba(15,23,42,0.25)', textAlign: 'center' }}>
        {/* クロックアイコン (amber circle) */}
        <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: '#FEF3C7', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
          <Clock size={26} style={{ color: '#B45309' }} />
        </div>

        <div style={{ fontSize: '18px', fontWeight: 700, color: '#0F172A', marginBottom: '10px' }}>
          セッションの有効期限が切れました
        </div>
        <div style={{ fontSize: '14px', color: '#64748B', lineHeight: 1.8, marginBottom: '28px' }}>
          セキュリティ保護のため、一定時間操作がないと自動的にログアウトされます。お手数ですが、再度ログインしてください。
        </div>

        <button
          data-testid="session-expired-login-button"
          onClick={() => {
            // ①email退避（clearAuth前）
            const email = (() => {
              const inMem = useAuthStore.getState().user?.email;
              if (inMem) return inMem;
              try {
                const raw = localStorage.getItem('entrybot_auth');
                return raw ? (JSON.parse(raw)?.state?.user?.email ?? '') : '';
              } catch { return ''; }
            })();
            if (email) sessionStorage.setItem('eb735_login_email', email);
            // ②clearAuth (isAuthenticated=false + token除去 → proactive再発火ループ解消)
            useAuthStore.getState().clearAuth();
            // ③遷移
            guardedNavigate('/login');
          }}
          style={{ width: '100%', background: '#0a7a72', color: '#fff', border: 'none', borderRadius: '8px', padding: '14px 20px', fontSize: '14px', fontWeight: 700, cursor: 'pointer' }}
        >
          ログイン画面へ
        </button>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
